/** 费用管理 cost **/
import Layout from "@/views/layout/Layout";

const costManRouter = {
  // path: '/supplyChainMan',
  // component: Layout,
  // redirect: '/hrMan/flowChart/list',
  // name: 'hrMan',
  // meta: {
  //   title: '人力资源',
  //   icon: 'user',
  //   roles: ['renliziyuan']
  // },

  ////

  path: "/costMan",
  component: Layout,
  name: "费用管理",
  // redirect: '/dataDic/departMan',
  // component: () => import('@/views/dataDic/index'),
  meta: {
    title: "费用管理",
    icon: "money",
    roles: ["feiyongguanlil"]
  },
  alwaysShow: true,
  children: [
    ///////// [[ roter temp ///////
    // 1 财务首页
    {
      path: "financeHome",
      name: "财务首页",
      component: () => import("@/views/costMan/home"),
      meta: {
        title: "财务首页",
        // icon: 'lock',
        roles: ["feiyongguanlil"]
      },
      children: []
    },
    // 2 设置维护
    {
      path: "financeConfig",
      component: () => import("@/views/costMan/financeConfig/index"),
      meta: {
        title: "设置维护",
        roles: ["shezhiweihu"]
      },
      children: [
        // 1 账期设置
        // {
        //   path: 'accountingPeriodSet',
        //   component: () => import('@/views/costMan/financeConfig/accountingPeriodSet'),
        // 	name: '账期设置',
        //   meta: {
        //     title: '账期设置',
        //     roles: ['jichudangan']
        //   }
        // },
        // 2 科目设置
        {
          path: "subjectSet",
          component: () => import("@/views/costMan/financeConfig/subjectSet"),
          name: "科目设置",
          meta: {
            title: "科目设置",
            roles: ["kemushezhi"]
          }
        },
        // 3 账户设置
        {
          path: "accountSet",
          component: () => import("@/views/costMan/financeConfig/accountSet"),
          name: "账户设置",
          meta: {
            title: "账户设置",
            roles: ["zhanghushezhi"]
          }
        }
        // // 3 短期项目设置
        // {
        //   path: 'shortTermProjectsSet',
        //   component: () => import('@/views/costMan/financeConfig/shortTermProjectsSet'),
        // 	name: '短期项目设置',
        //   meta: {
        //     title: '短期项目设置',
        //     roles: ['jichudangan']
        //   }
        // },
        // 4 审批设置
        // {
        //   path: 'approvalSet',
        //   component: () => import('@/views/costMan/financeConfig/approvalSet'),
        //   name: '审批设置',
        //   meta: {
        //     title: '审批设置',
        //     roles: ['jichudangan']
        //   }
        // },
      ]
    },
    // 3 基础查询
    {
      path: "basicsQuery",
      component: () => import("@/views/costMan/basicsQuery/index"),
      meta: {
        title: "基础查询",
        roles: ["jichuchaxun"]
      },
      alwaysShow: true,
      children: [
        // 1 部门查询
        {
          path: "departmentQuery",
          component: () =>
            import("@/views/costMan/basicsQuery/departmentQuery"),
          name: "部门查询",
          meta: {
            title: "部门查询",
            roles: ["bumenchaxun"]
          }
        },
        // 2 客户查询
        // {
        //   path: 'customerQuery',
        //   component: () => import('@/views/costMan/basicsQuery/customerQuery'),
        //   name: '客户查询',
        //   meta: {
        //     title: '客户查询',
        //     roles: ['jichudangan']
        //   }
        // },
        // 3 供应商查询
        {
          path: "supplierQuery",
          component: () => import("@/views/costMan/basicsQuery/supplierQuery"),
          name: "供应商查询",
          meta: {
            title: "供应商查询",
            roles: ["gongyingshangchaxun"]
          }
        }
      ]
    },

    // 4 预算管理
    {
      path: "budgetMan",
      component: () => import("@/views/costMan/basicsQuery/index"),
      meta: {
        title: "预算管理",
        roles: ["yusuanguanli"]
      },
      alwaysShow: true,
      children: [
        

        ////////////////
        // 1 预算计划
        {
          path: "budgetPlan",
          component: () => import("@/views/costMan/budgetMan/budgetPlan/index"),
          name: "预算策略",
          meta: {
            title: "预算策略",
            roles: ["yusuancelue"]
          }
        },
         // 2 预算计划审核
         {
          path: "budgetPlanAuth",
          component: () => import("@/views/costMan/budgetMan/budgetPlanAuth"),
          name: "预算策略审核",
          meta: {
            title: "预算策略审核",
            roles: ["yusuancelueshenhe"]
          }
        },
         // 2 预算策略变更
        {
          path: "budgetPlanChange",
          component: () => import("@/views/costMan/budgetMan/budgetPlanChange/index"),
          name: "预算策略变更",
          meta: {
            title: "预算策略变更",
            roles: ["yusuanceluebiangeng"]
          }
        },
       
        // 3 预算编制

        {
          path: "budgetOrganization",
          component: () =>
            import("@/views/costMan/budgetMan/budgetOrganization/index"),
          name: "预算计划",
          meta: {
            title: "预算计划",
            roles: ["yusuanjihua"]
          }
        },

        // 预算初审
        {
          path: "budgetAuth",
          component: () => import("@/views/costMan/budgetMan/budgetAuth/index"),
          name: "预算初审",
          meta: {
            title: "预算初审",
            roles: ["yusuanchushen"]
            // keepAlive: true
          }
        },

        // 预算复审
        {
          path: "budgetAuthReview",
          component: () =>
            import("@/views/costMan/budgetMan/budgetAuthReview/index"),
          name: "预算复审",
          meta: {
            title: "预算复审",
            roles: ["yusuanfushen"]
            // keepAlive: true
          }
        },

        // 5 预算变更
        // {
        //   path: 'budgetChange',
        //   component: () => import('@/views/costMan/budgetMan/budgetChange'),
        // 	name: '预算变更',
        //   meta: {
        //     title: '预算变更',
        //     roles: ['jichudangan']
        //   }
        // },
        // // 6 预算变更审核
        // {
        //   path: 'budgetChangeAuth',
        //   component: () => import('@/views/costMan/budgetMan/budgetChangeAuth'),
        // 	name: '变更审核',
        //   meta: {
        //     title: '变更审核',
        //     roles: ['jichudangan']
        //   }
        // },
        // 7 预算管控
        {
          path: "budgetControl",
          component: () =>
            import("@/views/costMan/budgetMan/budgetControl/index"),
          name: "预算管控",
          meta: {
            title: "预算管控",
            roles: ["yusuanguankong"]
          }
        },
        {
          path: "budgetStatisticsExport",
          component: () => import("@/views/costMan/budgetMan/budgetStatisticsExport"),
          name: "预算统计导出",
          meta: {
            title: "预算统计导出",
            roles: ["yusuantongjidaochu"]
          }
        },
        {
          path: "budgetEarlyWarnConfig",
          component: () => import("@/views/costMan/budgetMan/budgetEarlyWarnConfig"),
          name: "预算预警设置",
          meta: {
            title: "预算预警设置",
            roles: ["yusuanyujingshezhi"]
          }
        }
      ]
    },

    // 6 出纳管理
    {
      path: "cashierMan",
      component: () => import("@/views/costMan/cashierMan/index"),
      meta: {
        title: "出纳管理",
        roles: ["chunaguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "businessCashier",
          component: () => import("@/views/costMan/cashierMan/businessCashier"),
          name: "业务生成出纳-付款",
          meta: {
            title: "业务生成出纳-付款",
            roles: ["yewushengchengchuna-fukuan"]
          }
        },
        {
          path: "businessCashierColl",
          component: () =>
            import("@/views/costMan/cashierMan/businessCashierColl"),
          name: "业务生成出纳-收款",
          meta: {
            title: "业务生成出纳-收款",
            roles: ["yewushengchengchuna-shoukuan"]
          }
        },
        {
          path: "cashier",
          component: () => import("@/views/costMan/cashierMan/cashier"),
          name: "业务生成出纳-查询",
          meta: {
            title: "业务生成出纳-查询",
            roles: ["yewushengchengchuna-chaxun"]
          }
        }
      ]
    },

    // 6 报表
    {
      path: "reportForm",
      component: () => import("@/views/costMan/reportForm/index"),
      meta: {
        title: "统计报表",
        roles: ["tongjibaobiao"]
      },
      alwaysShow: true,
      children: [
        // 1 借款往来
        {
          path: "loanMan",
          component: () => import("@/views/costMan/reportForm/loanMan"),
          name: "借款往来",
          meta: {
            title: "借款往来",
            roles: ["jiekuanwanglai"]
          }
        },
        // 2 供应商往来
        {
          path: "supplierTransactions",
          component: () =>
            import("@/views/costMan/reportForm/supplierTransactions"),
          name: "供应商往来",
          meta: {
            title: "供应商往来",
            roles: ["gongyingshangwanglai"]
          }
        },
        // << ---- 0225 费用需求变更
        {
          path: "returnGoodsQuery",
          component: () =>
            import("@/views/costMan/reportForm/returnGoodsQuery"),
          name: "退货查询",
          meta: {
            title: "退货查询",
            roles: ["cw_tuihuochaxun"],
            keepAlive: true
          }
        },
        {
          path: "returnLibraryQuery",
          component: () =>
            import("@/views/costMan/reportForm/returnLibraryQuery"),
          name: "返库查询",
          meta: {
            title: "返库查询",
            roles: ["cw_fankuchaxun"],
            keepAlive: true
          }
        },
        {
          path: "inLibraryQuery",
          component: () => import("@/views/costMan/reportForm/inLibraryQuery"),
          name: "入库查询",
          meta: {
            title: "入库查询",
            roles: ["cw_rukuchaxun"],
            keepAlive: true
          }
        },
        {
          path: "outLibraryQuery",
          component: () => import("@/views/costMan/reportForm/outLibraryQuery"),
          name: "出库查询",
          meta: {
            title: "出库查询",
            roles: ["cw_chukuchaxun"],
            keepAlive: true
          }
        },
        {
          path: "receivableQuery",
          component: () => import("@/views/costMan/reportForm/receivableQuery"),
          name: "应收查询",
          meta: {
            title: "应收查询",
            roles: ["yingshouchaxun_web"],
            keepAlive: true
          }
        }
        // >> ---- 0225 费用需求变更
        // 3 客户往来
        // {
        //   path: 'customerContact',
        //   component: () => import('@/views/costMan/reportForm/customerContact'),
        //   name: '客户往来',
        //   meta: {
        //     title: '客户往来',
        //     roles: ['jichudangan']
        //   }
        // },
        // // 4 固定资产
        // {
        //   path: 'fixedAssets',
        //   component: () => import('@/views/costMan/reportForm/fixedAssets'),
        //   name: '固定资产',
        //   meta: {
        //     title: '固定资产',
        //     roles: ['jichudangan']
        //   }
        // },
      ]
    },

    //7薪酬
    {
      path: "salaryManagement",
      component: () => import("@/views/costMan/salaryManagement/index"),
      meta: {
        title: "薪酬管理",
        roles: ["xinchouguanli_feiyong"]
      },
      alwaysShow: true,
      children: [
        {
          path: "wagePayment",
          component: () =>
            import("@/views/costMan/salaryManagement/wagePayment"),
          name: "工资发放",
          meta: {
            title: "工资发放",
            roles: ["gongzifafang"]
          }
        },
        {
          path: "wageSupervisionExamination",
          component: () =>
            import(
              "@/views/costMan/salaryManagement/wageSupervisionExamination"
            ),
          name: "工资表监审",
          meta: {
            title: "工资表监审",
            roles: ["gongzibiaojianshen"]
          }
        },
        {
          path: "wageInquiry",
          component: () =>
            import("@/views/costMan/salaryManagement/wageInquiry"),
          name: "工资表查询(会计入账)",
          meta: {
            title: "工资表查询(会计入账)",
            roles: ["gongzibiaochaxunkuaijiruzhang"]
          }
        },
        {
          path: "financeInquiry",
          component: () =>
            import("@/views/costMan/salaryManagement/financeInquiry"),
          name: "发放失败查询(财务)",
          meta: {
            title: "发放失败查询(财务)",
            roles: ["caiwufafangshibaichaxun"]
          }
        }
      ]
    }
  ]
};

export default costManRouter;
